import { useNavigate, useRouterState } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Button } from "@devhop/ui";
import { ArrowLeft, HelpCircle } from "lucide-react";
import { OTPlaceholderTour, useOTPlaceholderTour } from "../tour/OTPlaceholderTour";

export function OTPlaceholderPage() {
  const nav = useNavigate();
  const tour = useOTPlaceholderTour();
  const path = useRouterState({ select: (s) => s.location.pathname }) ?? "";
  const isRequest = path.includes("/requests/");
  const isEdit = path.includes("/edit");
  const title = isRequest
    ? "ຄຳຂໍ OT"
    : isEdit
      ? "ຈັດການຂໍ້ກຳນົດ OT"
      : "ສ້າງຂໍ້ກຳນົດ OT";
  const backTo = isRequest ? "/app/hr/overtime/requests" : "/app/hr/overtime/rules";
  const search = isRequest
    ? { offset: 0, limit: 20, status: undefined as string | undefined, search: undefined as string | undefined }
    : { offset: 0, limit: 20, dayType: undefined as "weekday" | "holiday" | undefined, isActive: undefined as boolean | undefined, search: undefined as string | undefined };
  return (
    <>
      <Header />
      <Main>
        <OTPlaceholderTour run={tour.run} onCallback={tour.handleJoyrideCallback} />
        <div className="flex flex-col items-center justify-center gap-4 py-12">
          <div className="flex items-center gap-2">
            <h1 className="font-semibold text-xl">{title}</h1>
            <Button
              variant="ghost"
              size="icon"
              className="size-7 rounded-full"
              onClick={tour.startTour}
              title="ເລີ່ມທົດສອບການນຳທາງ"
              aria-label="ເລີ່ມທົດສອບການນຳທາງ"
            >
              <HelpCircle className="size-5" />
            </Button>
          </div>
          <p className="text-muted-foreground text-sm">ຟອມຈະເຂົ້າມາກວ່ານີ້.</p>
          <div data-tourid="ot-placeholder-back">
            <Button variant="outline" onClick={() => nav({ to: backTo, search })}>
              <ArrowLeft className="h-4 w-4" />
              ກັບຄືນ
            </Button>
          </div>
        </div>
      </Main>
    </>
  );
}
